<template>
  <a-button danger type="primary" @click="showConfirm">{{ $t("restart") }}</a-button>
  <v-loading :show="loading"></v-loading>
</template>

<script>
// zhouhan@cibr.ac.cn 2022/11/15 16:25
import VLoading from "@/components/public/v-loading";
import util from "@/util/util";
import {Modal} from 'ant-design-vue';
import {createVNode} from 'vue';
import {ExclamationCircleOutlined} from '@ant-design/icons-vue';

export default {
  name: "restartTask",
  components: {VLoading},
  props: {
    taskId: String,
    status: String
  },
  data() {
    return {
      loading: false
    }
  },
  mounted() {
  },
  methods: {
    showConfirm() {
      Modal.confirm({
        title: 'Are you sure you want to start again from this step?',
        icon: createVNode(ExclamationCircleOutlined),
        onOk: () => {
          var post = {
            taskId : this.taskId,
            status : this.status
          }
          util.$post("/task/restart", post, () => {
            Modal.success({
              title: this.$t("restartSuccess"),
            });
            this.$emit("restart");
          }, this.showMask, this.hideMask);
        },
        class: 'test',
      });
    },
    showMask() {
      this.loading = true;
    },
    hideMask() {
      this.loading = false;
    },
  }
}
</script>

<style scoped>

</style>